var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8571 11.1429V14.5714C10.8571 15.359 10.2166 16 9.42857 16H1.42857C0.640544 16 0 15.359 0 14.5714V1.42857C0 0.640952 0.640544 0 1.42857 0H9.42857C10.2166 0 10.8571 0.640952 10.8571 1.42857V4.85714C10.8571 5.33068 10.4732 5.71425 10 5.71425C9.5269 5.71425 9.14292 5.33068 9.14292 4.85714V1.71422H1.71435V14.2856H9.14292L9.14306 11.1427C9.14306 10.6692 9.52704 10.2856 10.0002 10.2856C10.4733 10.2856 10.8573 10.6692 10.8573 11.1427L10.8571 11.1429Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8327 8.40409L13.547 10.6898C13.3841 10.8527 13.139 10.9024 12.9241 10.8136C12.7104 10.7252 12.5715 10.5168 12.5715 10.2857V9.14278L8.57151 9.14291C7.94039 9.14291 7.42859 8.63111 7.42859 7.99999C7.42859 7.36887 7.94039 6.85706 8.57151 6.85706H12.5715V5.71414C12.5715 5.48308 12.7104 5.27475 12.9243 5.18625C13.1386 5.09802 13.3841 5.14665 13.5471 5.31008L15.8328 7.59576C16.0558 7.81924 16.0558 8.18062 15.8325 8.40399L15.8327 8.40409Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.dd4a3bcfe3146dd3f3f82de4db99600b.svg";
export { ForwardRef as ReactComponent };